import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import uniqueId from 'lodash/uniqueId';
import SkeletonElement from '../../../../components/skeletons/SkeletonElement';
import ArticleCardSkeleton from './ArticleCardSkeleton';

const ARTICLES_COUNT = 4;

const ArticlesListSkeleton = () => {
  const articlesListSkeleton = [...Array(ARTICLES_COUNT)].map(() => (
    <Col
      key={uniqueId()}
      className="mb-6"
      xs={12}
      md={6}
      lg={4}
      xl={3}
    >
      <ArticleCardSkeleton />
    </Col>
  ));

  return (
    <Container className="my-md-3">
      <Row>
        <Col xs={12} className="my-4">
          <div className="articles-list-header">
            <SkeletonElement type="label-short" className="mx-auto mx-md-0" />
          </div>
        </Col>
        {articlesListSkeleton}
      </Row>
    </Container>
  );
};

export default ArticlesListSkeleton;
